import React from 'react';
import emptySearchQuery from 'assets/images/empty-search-query.svg';
import emptySearchResults from 'assets/images/empty-search-results.svg';
import { useIntl } from 'react-intl';
import Heading from '@atlaskit/heading';
import { Stack, Text } from '@atlaskit/primitives';
import { ExperienceSuccess } from '@atlassian/ufo';
import { Img } from '../common';
import { searchExperience } from '../experiences';
import messages from './messages';

export interface Props {
    term: string;
}

export const SearchResultNone = ({ term }: Props) => {
    const { formatMessage } = useIntl();
    const showEmptyQueryState = term === '';

    const emptyQueryContent = (
        <Stack space="space.100" alignInline="center">
            <Img src={emptySearchQuery} alt="" />
            <Heading as="h2" size="xsmall">
                {formatMessage(messages.noSearchQueryTitle)}
            </Heading>
            <Text align="center">{formatMessage(messages.noSearchQueryBody)}</Text>
            <ExperienceSuccess experience={searchExperience} />
        </Stack>
    );

    const noResultsContent = (
        <Stack space="space.100" alignInline="center">
            <Img src={emptySearchResults} alt="" />
            <Heading as="h2" size="xsmall">
                {formatMessage(messages.noSearchResultTitle)}
            </Heading>
            <Text align="center">{formatMessage(messages.noSearchResultBody)}</Text>
            <ExperienceSuccess experience={searchExperience} />
        </Stack>
    );

    return showEmptyQueryState ? emptyQueryContent : noResultsContent;
};
